import React, { Fragment } from "react";
import { Card, CardBody, CardHeader, Col, Table } from "reactstrap";
import { H3, H5, Image, P } from "../../../AbstractElements";
import { agentName, CollectionsAgent, CustomerName, Name, ProblemType, Progress, serviceAgentCollection, Status, ThisMonth, Today } from "../../../Constant";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const ServiceAgent = ({collection}) => {
    const authState = useSelector((state) => state.auth);
    const agent = collection

    return (
        <Fragment>
            <Col xl="12" >
                <Card className="transaction-history">                   
                    <CardHeader className="pb-0">
                        <H3>{serviceAgentCollection}</H3>
                    </CardHeader>
                    <CardBody>
                        <div className="dashboardTable">
                            {
                                agent?.length>0
                                ?
                        <table className="table table-bordernone tble-responsive">
                            <thead> 
                                <tr>
                                    <th>{agentName}</th>
                                    <th style={{whiteSpace:'nowrap'}}>{CustomerName}</th>
                                    <th>{Status}</th>
                                    <th  style={{whiteSpace:'nowrap'}}>{ProblemType}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {agent?.map((item,index) => {
                                    return (<tr key={index}>
                                        <td>
                                            {/* <div className="d-flex">
                                                <div className="flex-grow-1">
                                                    <Link style={{color:'#534686', marginLeft:'13px'}} to={`${process.env.PUBLIC_URL}/report/payment-collection?user=${item.agent_id}`}>
                                                    </Link>
                                                    </div>
                                                    </div> */}
                                                    <H5 >
                                                        <Link to={`/service-request?agent_id=${item?.user_id}`} className="ms-3">
  
                                                        {item.assigned_user}
                                                        </Link>
                                                        </H5>
                                        </td >
                                        <td>
                                            <H5> {item?.customer_name}</H5>
                                        </td>
                                        <td>
                                            <span className={`badge badge-${item?.status}`}>{item?.status}</span>
                                        </td>
                                        <td>
                                                <H5>{item.problem_type}</H5>
                                            <div className="progress-showcase">
                                                {/* <div className={`progress ${item.class}`} style={{ height: "5px" }}>
                                                    <div className="progress-bar" role="progressbar" style={{ width: `${item.progress}` }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div > */}
                                            </div >
                                        </td >
                                    </tr >)
                                })}
                            </tbody>
                        </table>
                        :
                        
                        <div className="py-5">

                            <p className="text-center">No Data Found</p>
                        </div>

                            }
                        </div>
                    </CardBody>
                </Card>
            </Col >
        </Fragment >
    )
}

export default ServiceAgent;
